import React from 'react'
import { SetStateAction } from "react";
import { TCNRColumnsIDs } from "redux/app/vessel/onboard/types";
import StatusMenu from "./StatusMenu";
import ActionMenu from "./ActionMenu";
import { getDocStatusConfig } from 'redux/app/tool/utils';
import classNames from 'classnames';

type StickyColumnsProps = {
	report: any;
	reportItem?: any;
	index?: number;
	reportType: keyof TCNRColumnsIDs;
	isFirstRow: boolean;
	totalSubRows: number;
	isSignalStatusEnabled?: boolean;
	isIMOSStatusEnabled?: boolean;
	isDocStatusEnabled?: boolean;
	stickyOffsets: Record<string, { sm: number; lg: number }>;
	setStatusModalOpen: React.Dispatch<SetStateAction<boolean>>;
	setErrorDetails: React.Dispatch<SetStateAction<any>>;
	onClickView: () => void;
	onClickTools: () => void;
};

function StickyColumns(props: StickyColumnsProps) {
	const {
		report,
		reportItem,
		index,
		reportType,
		isFirstRow,
		totalSubRows,
		isSignalStatusEnabled,
		isIMOSStatusEnabled,
		isDocStatusEnabled,
		stickyOffsets,
		setStatusModalOpen,
		setErrorDetails,
		onClickView,
		onClickTools,
	} = props;

	const docStatusConfig = getDocStatusConfig(report?.doc_status);

	return (
		<>
			{isSignalStatusEnabled &&
				<StatusMenu
					type="Signal"
					setStatusModalOpen={setStatusModalOpen}
					setErrorDetails={setErrorDetails}
					report={report}
					reportItem={reportItem}
					index={index ?? 0}
					report_type={reportType}
					lastProcessedDate={report?.signalApiLastProcessedDate}
					offset={stickyOffsets?.["signalStatus"]}
				/>
			}
			{isIMOSStatusEnabled &&
				<StatusMenu
					type="IMOS"
					setStatusModalOpen={setStatusModalOpen}
					setErrorDetails={setErrorDetails}
					report={report}
					reportItem={reportItem}
					index={index ?? 0}
					report_type={reportType}
					lastProcessedDate={report?.imosApiLastProcessedDate}
					offset={stickyOffsets?.["imosStatus"]}
				/>
			}
			{isFirstRow && isDocStatusEnabled &&
				<td
					className={classNames(
						"border text-[9px] lg:text-[12px] xl:text-sm text-center font-medium p-0 lg:px-2 min-w-10 lg:min-w-32 sticky z-1 bg-white cursor-pointer",
						docStatusConfig?.className
					)}
					rowSpan={totalSubRows}
					style={{ right: window.innerWidth < 1024 ? stickyOffsets?.["doc_status"]?.sm : stickyOffsets?.["doc_status"]?.lg }}
				>
					{/* Capitalize */}
					{docStatusConfig?.label}
				</td>
			}
			{isFirstRow &&
				<ActionMenu
					onClickView={onClickView}
					onClickDownload={() => console.log("download")}
					onClickTools={onClickTools}
					report={report}
					rowSpan={totalSubRows}
				/>
			}
		</>
	)
};

export default StickyColumns
